"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ServiceUrlsProvider = require("./ServiceUrlsProvider");
Object.keys(_ServiceUrlsProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ServiceUrlsProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ServiceUrlsProvider[key];
    }
  });
});
var _useServiceUrls = require("./useServiceUrls");
Object.keys(_useServiceUrls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useServiceUrls[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useServiceUrls[key];
    }
  });
});
//# sourceMappingURL=index.js.map